<script setup lang="ts">
import { computed } from "vue";
import LucideIcon from "../../components/icons/LucideIcon.vue";
import { useHelpPanelStore } from "./helpPanelStore.ts";
import { findHelpTopic } from "./helpTopics.ts";

// The inline "!" marker. Renders nothing when the topic is unknown, so a page
// without help copy simply has no marker rather than a dead button.
const props = withDefaults(
  defineProps<{
    topicId: string;
    /** Falls back to the topic title. */
    label?: string;
    size?: number;
  }>(),
  { size: 16 }
);

const helpPanel = useHelpPanelStore();

const topic = computed(() => findHelpTopic(props.topicId));
const buttonLabel = computed(
  () => `Help: ${props.label ?? topic.value?.title ?? props.topicId}`
);
</script>

<template>
  <button
    v-if="topic"
    type="button"
    class="help-marker"
    :aria-label="buttonLabel"
    :title="buttonLabel"
    @click="helpPanel.open(topicId)"
  >
    <LucideIcon name="circle-alert" :size="size" />
  </button>
</template>
